module.exports = require("@nestjs/common");